// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"LoadingSpinner_lds-dual-ring__+ci3S"};